import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./TextField.module.scss";
export const TextField = React.forwardRef(({ label, hint, error, className, id, ...rest }, ref) => {
    const reactId = React.useId();
    const inputId = id ?? reactId;
    return (_jsxs("div", { className: cn(styles.wrap, className), children: [label && (_jsx("label", { className: styles.label, htmlFor: inputId, children: label })), _jsx("input", { ref: ref, id: inputId, className: cn(styles.field, error ? styles.invalid : undefined), ...rest }), error ? (_jsx("span", { className: styles.error, children: error })) : hint ? (_jsx("span", { className: styles.hint, children: hint })) : null] }));
});
TextField.displayName = "TextField";
